var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _g, _path58, _g2, _path59, _g3, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReactNativeDevelopent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M202.711 161.578V170.794C202.711 174.269 205.436 177.103 208.8 177.14L221.857 177.304C222.973 185.552 225.185 193.452 228.367 200.894L216.664 207.514C213.72 209.178 212.714 213 214.414 216.072L218.931 224.265C220.632 227.355 224.417 228.525 227.398 226.898L239.504 220.205C244.423 226.788 250.201 232.731 256.693 237.87L249.433 250.232C247.678 253.212 248.72 257.199 251.756 259.119L259.893 264.276C262.965 266.233 266.915 265.373 268.689 262.374L276.168 249.811C283.648 253.249 291.694 255.791 300.161 257.235V272.487C300.161 276.126 303.141 279.253 306.854 279.472L316.747 280.057C320.495 280.277 323.531 277.479 323.531 273.803V258.388C332.235 257.766 340.666 255.992 348.62 253.194L356.666 267.037C358.605 270.365 362.92 271.719 366.303 270.036L375.355 265.519C378.775 263.819 379.945 259.704 377.97 256.339L369.851 242.57C377.111 237.705 383.658 231.854 389.29 225.197L403.371 233.371C406.882 235.401 411.38 234.45 413.428 231.195L418.878 222.546C420.926 219.291 419.719 214.993 416.153 212.982L402.218 205.082C405.949 197.164 408.582 188.642 409.917 179.682L425.699 179.883C429.831 179.938 433.196 176.847 433.196 172.989V162.73C433.196 158.872 429.831 155.726 425.699 155.726L410.319 155.708C409.277 146.528 406.882 137.769 403.316 129.576L416.135 122.481C419.682 120.524 420.907 116.245 418.859 112.954L413.41 104.231C411.362 100.958 406.863 99.9336 403.352 101.927L390.972 108.931C385.303 101.744 378.592 95.3985 371.113 90.0954L377.952 78.5748C379.927 75.2466 378.757 71.1138 375.337 69.3583L366.285 64.7135C362.902 62.9762 358.586 64.2563 356.648 67.5662L350.047 78.8308C341.671 75.6123 332.766 73.5459 323.513 72.7596V60.3064C323.513 56.6308 320.459 53.7963 316.728 53.9609L306.835 54.4181C303.141 54.5827 300.142 57.6731 300.142 61.2939V73.6191C291.182 75.0454 282.679 77.6787 274.815 81.3361L268.689 70.9492C266.897 67.9136 262.965 67.0176 259.893 68.9194L251.756 73.9665C248.72 75.8501 247.678 79.8183 249.433 82.8356L255.541 93.3321C248.866 98.7084 242.96 104.944 238.022 111.875L227.398 105.84C224.435 104.158 220.65 105.273 218.931 108.345L214.414 116.465C212.714 119.519 213.72 123.359 216.664 125.059L227.416 131.295C224.417 138.866 222.387 146.93 221.51 155.342L208.782 155.324C205.436 155.306 202.711 158.122 202.711 161.578ZM246.837 165.071C246.837 129.869 275.419 100.647 311.773 99.7507C349.407 98.8364 380.915 128.443 380.915 165.93C380.915 203.4 349.425 232.622 311.773 231.214C275.419 229.879 246.837 200.273 246.837 165.071Z",
    fill: "#BFC8D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M353.887 64.2015L362.957 63.8906L366.084 72.0282L353.887 64.2015Z",
    fill: "#BFC8D6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M264.063 67.9502L253.621 68.0599V75.7769L264.063 67.9502Z",
    fill: "#BFC8D6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.252 105.127L213.828 105.548L216.443 111.381L224.252 105.127Z",
    fill: "#BFC8D6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.904 155.434L197.389 156.256L200.827 161.358L207.904 155.434Z",
    fill: "#BFC8D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.403 227.593L215.199 229.056L213.938 220.717L225.403 227.593Z",
    fill: "#BFC8D6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M264.446 265.19L255.284 266.854L254.553 260.088L264.446 265.19Z",
    fill: "#BFC8D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M310.271 281.429L318.482 279.966L311.405 269.451L310.271 281.429Z",
    fill: "#BFC8D6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M354.836 272.578L364.418 270.603L357.012 261.643L354.836 272.578Z",
    fill: "#BFC8D6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M408.673 100.976L398.67 101.286L402.62 108.565L408.673 100.976Z",
    fill: "#BFC8D6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M428.55 179.371L419.389 180.724L420.12 173.227L428.55 179.371Z",
    fill: "#BFC8D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M408.875 234.249L399.914 235.712L399.201 229.787L408.875 234.249Z",
    fill: "#BFC8D6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.379 162.456V171.746C192.379 175.239 195.122 178.11 198.523 178.146L211.69 178.311C212.823 186.613 215.054 194.604 218.255 202.084L206.46 208.758C203.497 210.441 202.491 214.299 204.192 217.39L208.745 225.655C210.464 228.764 214.286 229.952 217.267 228.307L229.464 221.559C234.42 228.179 240.253 234.177 246.8 239.37L239.485 251.823C237.712 254.841 238.772 258.845 241.826 260.784L250.018 265.977C253.109 267.952 257.095 267.093 258.888 264.057L266.422 251.384C273.974 254.859 282.075 257.401 290.597 258.864V274.243C290.597 277.9 293.614 281.064 297.344 281.283L307.329 281.887C311.114 282.106 314.186 279.29 314.186 275.596V260.052C322.964 259.431 331.449 257.638 339.477 254.804L347.596 268.757C349.553 272.122 353.905 273.475 357.306 271.774L366.431 267.221C369.888 265.502 371.076 261.351 369.065 257.968L360.872 244.07C368.205 239.169 374.788 233.262 380.476 226.551L394.684 234.78C398.232 236.828 402.767 235.859 404.833 232.586L410.319 223.881C412.386 220.59 411.161 216.274 407.576 214.244L393.532 206.271C397.299 198.298 399.951 189.685 401.304 180.67L417.213 180.871C421.383 180.926 424.784 177.817 424.784 173.922V163.572C424.784 159.677 421.383 156.513 417.213 156.513L401.706 156.495C400.646 147.242 398.232 138.409 394.648 130.162L407.576 123.012C411.161 121.037 412.386 116.721 410.319 113.412L404.833 104.616C402.767 101.324 398.232 100.282 394.684 102.293L382.195 109.352C376.471 102.11 369.723 95.71 362.171 90.3703L369.083 78.7583C371.076 75.3936 369.888 71.2425 366.45 69.4687L357.325 64.7873C353.905 63.0318 349.571 64.3301 347.614 67.6583L340.958 79.0143C332.51 75.7776 323.531 73.6746 314.205 72.9066V60.3436C314.205 56.6314 311.133 53.7787 307.347 53.9433L297.363 54.4005C293.632 54.565 290.615 57.6738 290.615 61.3494V73.766C281.581 75.1924 273.005 77.8623 265.068 81.5562L258.888 71.0779C257.095 68.024 253.109 67.1097 250.018 69.0298L241.826 74.1135C238.754 76.0153 237.712 80.0018 239.485 83.0374L245.648 93.6254C238.918 99.0382 232.957 105.329 227.983 112.314L217.267 106.243C214.268 104.543 210.464 105.676 208.745 108.767L204.192 116.959C202.491 120.031 203.497 123.908 206.46 125.627L217.304 131.918C214.268 139.561 212.238 147.681 211.36 156.166L198.542 156.147C195.14 156.147 192.379 158.964 192.379 162.456ZM236.889 165.986C236.889 130.491 265.708 101.031 302.373 100.135C340.318 99.2211 372.082 129.065 372.082 166.845C372.082 204.625 340.318 234.067 302.373 232.659C265.69 231.306 236.889 201.462 236.889 165.986Z",
    fill: "#EAEDF3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M275.148 55.3515L323.078 453.708C323.791 459.688 319.677 465.028 313.916 465.613L114.281 487.539C102.047 488.307 95.354 482.053 94.6043 475.707L44.2794 52.1879C43.5296 45.879 49.5276 40.1553 61.8163 40.1553L263.262 44.3978C269.096 44.4709 274.435 49.4083 275.148 55.3515Z",
    fill: "url(#paint0_linear_252_3717)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M284.127 54.6751L332.312 455.025C333.044 461.023 328.911 466.418 323.114 466.985L116.182 487.594C109.69 488.234 103.747 483.552 102.997 477.17L52.3981 51.4567C51.6484 45.1112 56.4029 40.0092 62.9678 40.1189L272.204 43.63C278.056 43.7397 283.414 48.6954 284.127 54.6751Z",
    fill: "url(#paint1_linear_252_3717)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M280.215 76.7652L324.871 447.966C325.547 453.58 321.671 458.591 316.258 459.121L121.633 478.048C115.598 478.633 110.076 474.244 109.362 468.319L62.6033 75.0463C61.9085 69.1397 66.3155 64.3486 72.4233 64.4217L269.06 66.5247C274.528 66.5613 279.538 71.1695 280.215 76.7652Z",
    fill: "#D8DEE8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M175.833 54.4003C176.089 56.5398 174.553 58.2405 172.413 58.2039C170.274 58.1856 168.317 56.4301 168.061 54.2905C167.805 52.151 169.341 50.4503 171.481 50.4869C173.639 50.5052 175.577 52.2607 175.833 54.4003Z",
    fill: "url(#paint2_linear_252_3717)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M246.549 325.939C206.702 252.262 147.179 230.227 129.258 154.301C119.566 113.265 126.168 73.9856 137.286 41.3621L62.9327 40.1004C56.3677 39.9906 51.6132 45.0926 52.363 51.4381L102.962 477.152C103.712 483.534 109.673 488.233 116.147 487.575L278.825 471.373C280.069 405.395 264.324 358.782 246.549 325.939Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M136.406 131.406C138.016 145.523 129.147 157.263 116.529 157.592C103.838 157.94 92.1893 146.62 90.6167 132.357C89.0257 118.093 98.0959 106.408 110.769 106.243C123.35 106.061 134.797 117.307 136.406 131.406Z",
    fill: "#BFC8D6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M273.886 128.553C275.551 142.158 267.45 153.459 255.728 153.788C243.933 154.118 232.979 143.2 231.333 129.449C229.688 115.716 237.971 104.451 249.748 104.286C261.452 104.104 272.222 114.966 273.886 128.553Z",
    fill: "#BFC8D6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M193.461 104.433L169.377 104.762C164.641 104.835 161.294 109.26 161.916 114.655L165.189 142.981C165.811 148.394 170.182 152.691 174.936 152.563L199.056 151.923C203.738 151.795 207.011 147.351 206.371 141.993L203.079 113.978C202.421 108.639 198.124 104.359 193.461 104.433Z",
    fill: "#BFC8D6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.117 212.489C217.763 226.478 209.278 238.328 197.099 238.932C184.829 239.535 173.509 228.545 171.882 214.391C170.254 200.255 178.922 188.46 191.156 188.022C203.335 187.583 214.472 198.536 216.117 212.489Z",
    fill: "#BFC8D6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M283.761 209.6C285.444 223.333 277.325 234.963 265.585 235.53C253.771 236.115 242.781 225.308 241.117 211.41C239.453 197.53 247.737 185.955 259.55 185.534C271.29 185.132 282.097 195.885 283.761 209.6Z",
    fill: "#BFC8D6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M132.64 189.466L107.587 190.362C102.65 190.544 99.1391 195.189 99.7608 200.748L102.998 229.897C103.619 235.475 108.136 239.809 113.073 239.571L138.163 238.346C143.027 238.108 146.447 233.445 145.825 227.922L142.552 199.103C141.948 193.598 137.504 189.301 132.64 189.466Z",
    fill: "#BFC8D6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M155.627 300.43C157.272 314.821 148.385 327.256 135.694 328.171C122.93 329.085 111.208 318.003 109.599 303.429C107.99 288.872 117.06 276.492 129.806 275.761C142.46 275.029 153.981 286.056 155.627 300.43Z",
    fill: "#BFC8D6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M212.899 270.274L188.706 271.683C183.933 271.957 180.587 276.638 181.227 282.161L184.555 311.054C185.195 316.576 189.584 320.801 194.357 320.453L218.587 318.734C223.286 318.405 226.56 313.687 225.92 308.219L222.555 279.637C221.915 274.188 217.599 270 212.899 270.274Z",
    fill: "#BFC8D6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M281.019 266.324L257.685 267.678C253.095 267.952 249.876 272.542 250.535 277.955L253.918 306.299C254.558 311.73 258.837 315.863 263.427 315.534L286.779 313.87C291.314 313.541 294.441 308.932 293.783 303.556L290.363 275.504C289.723 270.165 285.535 266.05 281.019 266.324Z",
    fill: "#BFC8D6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M235.887 380.05C237.569 394.313 229.066 406.84 216.832 408.01C204.507 409.181 193.114 398.41 191.45 383.963C189.786 369.535 198.472 357.064 210.779 356.076C222.995 355.07 234.205 365.805 235.887 380.05Z",
    fill: "#BFC8D6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M151.95 360.136L126.77 362.165C121.814 362.568 118.285 367.487 118.925 373.156L122.234 402.908C122.875 408.595 127.41 412.838 132.384 412.381L157.601 410.022C162.483 409.564 165.921 404.627 165.281 398.995L161.935 369.59C161.295 363.976 156.833 359.752 151.95 360.136Z",
    fill: "#BFC8D6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M291.039 348.925L267.65 350.809C263.042 351.174 259.842 355.911 260.482 361.36L263.901 389.997C264.56 395.483 268.839 399.579 273.447 399.14L296.854 396.946C301.389 396.525 304.534 391.771 303.876 386.358L300.42 358.032C299.78 352.637 295.574 348.559 291.039 348.925Z",
    fill: "#BFC8D6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M262.418 118.276H135.344C132.912 118.276 130.553 118.697 128.322 119.191C128.249 119.209 128.194 119.3 128.121 119.319C128.139 119.172 128.158 119.081 128.176 118.935C113.803 122.117 104.165 134.954 105.738 150.26L105.775 150.644L119.124 280.059L119.16 280.443C120.989 298.089 137.136 311.585 155.057 310.579L281.162 303.52C286.703 303.209 291.732 301.381 295.883 298.473C304.075 292.731 308.921 282.728 307.787 271.647L295.371 148.76C293.707 132.01 279.004 118.276 262.418 118.276Z",
    fill: "url(#paint3_linear_252_3717)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M303.473 148.687L315.853 271.19C316.968 282.253 312.378 292.256 304.222 297.98C300.09 300.887 295.317 302.716 289.794 303.027L164.366 310.067C146.537 311.073 129.987 297.651 128.158 280.041L114.827 150.589C113.255 135.32 123.203 122.373 137.485 119.209C139.697 118.716 142.294 118.295 144.708 118.295H271.105C287.6 118.277 301.772 131.973 303.473 148.687Z",
    fill: "url(#paint4_linear_252_3717)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M194.393 282.675C191.869 282.803 189.51 282.345 187.389 281.303C179.581 277.536 175.814 266.582 176.801 250.49C177.752 235.129 182.854 216.696 191.174 198.666C206.078 166.353 227.199 143.897 242.56 143.769C244.992 143.751 247.278 144.299 249.326 145.378C256.805 149.346 260.408 160.117 259.493 175.734C258.616 190.693 253.751 208.65 245.778 226.37C231.222 258.646 210.101 281.906 194.393 282.675ZM242.981 147.902C236.599 147.957 228.351 153.04 219.775 162.239C210.796 171.857 202.018 185.499 195.051 200.641C186.968 218.214 181.976 236.135 181.062 251.002C180.202 264.991 183.128 274.683 189.09 277.573C190.534 278.267 192.18 278.578 193.954 278.505C200.519 278.194 208.913 272.745 217.58 263.181C226.523 253.306 235.19 239.555 241.993 224.486C249.801 207.169 254.556 189.687 255.415 175.185C256.22 161.58 253.404 152.053 247.68 149.017C246.29 148.249 244.699 147.883 242.981 147.902Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 242.334C199.823 243.065 180.713 240.926 165.938 236.262C150.303 231.343 141.104 224.029 140.153 215.727C139.184 207.242 146.92 199.159 161.823 192.996C175.959 187.163 194.995 183.615 215.33 182.993C216.135 182.975 216.939 182.957 217.726 182.939C237.311 182.573 255.78 184.987 269.788 189.723C284.362 194.642 292.829 201.719 293.707 209.655C294.621 217.756 287.562 225.546 273.738 231.618C260.407 237.469 242.083 241.255 222.041 242.224C221.237 242.279 220.432 242.315 219.646 242.334ZM218.128 187.09C217.341 187.108 216.555 187.126 215.769 187.145C195.928 187.785 177.403 191.241 163.725 196.91C150.76 202.286 143.719 209.089 144.451 215.562C145.182 221.889 153.411 227.997 166.98 232.276C181.28 236.793 199.859 238.877 219.207 238.201C219.993 238.164 220.779 238.146 221.566 238.109C241.132 237.195 258.98 233.538 271.909 227.887C283.96 222.602 290.433 216.037 289.738 209.838C289.062 203.767 281.436 197.86 268.782 193.6C255.213 189.01 237.256 186.706 218.128 187.09Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M256.293 278.651C241.024 279.273 215.514 258.791 194.137 227.521C182.196 210.076 173.363 192.283 169.285 177.032C165.006 161.067 166.524 150.077 173.528 145.871C175.43 144.737 177.697 144.207 180.221 144.189C196.02 144.079 221.786 166.096 242.816 197.421C254.355 214.593 262.822 232.203 266.717 246.997C270.776 262.43 269.35 272.817 262.73 277.17C260.901 278.376 258.725 278.651 256.293 278.651ZM180.66 148.45C178.867 148.468 177.295 148.87 175.996 149.638C170.657 152.857 169.724 162.677 173.436 176.556C177.386 191.314 185.999 208.851 197.63 225.875C207.651 240.541 219.153 253.58 230.015 262.632C240.402 271.281 249.619 275.871 255.964 275.56C257.683 275.487 259.183 275.03 260.426 274.225C265.491 270.897 266.369 261.278 262.822 247.819C259.036 233.464 250.771 216.348 239.488 199.561C229.668 184.95 218.239 171.729 207.322 162.384C196.734 153.351 187.261 148.377 180.66 148.45Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M231.569 212.27C232.3 219.384 227.125 225.345 219.993 225.565C212.843 225.784 206.425 220.17 205.693 213.002C204.962 205.834 210.192 199.872 217.36 199.707C224.492 199.525 230.837 205.157 231.569 212.27Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M304.203 297.504C300.07 300.412 295.06 302.076 289.537 302.387L164.091 309.391C146.261 310.378 129.931 297.285 128.121 279.675L114.79 150.205C113.217 134.936 123.055 122.135 137.337 118.972C137.155 120.27 137.1 121.258 137.063 121.751C136.332 132.083 138.179 142.982 143.793 152.491C154.728 171.034 174.587 175.587 192.856 182.225C212.404 189.32 233.269 205.212 240.145 225.181C243.144 233.885 243.254 243.12 245.43 251.952C251.976 278.486 270.062 300.193 298.443 298.181C300.326 298.053 302.247 297.779 304.203 297.504Z",
    fill: "url(#paint5_linear_252_3717)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9508 475.762C31.0181 475.287 29.4638 475.817 28.4397 476.164C27.9826 476.311 27.7631 476.402 27.6168 476.512C26.6476 477.371 27.5071 479.602 28.6774 483.187C30.5244 488.855 30.817 490.648 31.8045 490.721C32.7371 490.776 33.5417 489.276 33.6331 489.111C34.1086 488.197 34.0537 487.374 33.9074 485.783C33.6148 482.857 33.304 480.919 33.2125 480.334C32.6639 476.695 32.5725 476.073 31.9508 475.762Z",
    fill: "url(#paint6_linear_252_3717)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3344 476.786L32.3912 480.078C32.0255 480.06 30.3065 478.615 30.4345 476.823L35.884 472.727L38.3344 476.786Z",
    fill: "url(#paint7_linear_252_3717)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M99.6856 362.349C101.752 370.139 104.093 381.33 104.842 394.935C105.464 406.2 104.952 418.653 103.599 425.419C96.7963 459.323 43.1066 477.134 36.7795 479.164C35.4445 477.372 34.1279 475.598 32.793 473.806C39.4859 468.832 72.1459 443.797 72.475 415.91C72.5299 411.43 71.7984 401.72 69.9149 391.37C67.9034 380.288 65.0689 371.309 62.8197 365.073C75.09 364.159 87.3787 363.245 99.6856 362.349Z",
    fill: "url(#paint8_linear_252_3717)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8828 265.301L97.6739 266.252C97.6739 266.252 122.818 298.326 119.216 310.542C115.631 322.757 97.6739 313.413 97.6739 313.413L92.8828 265.301Z",
    fill: "url(#paint9_linear_252_3717)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3374 493.702C60.5327 494.36 60.3865 496.006 60.2767 497.067C60.2402 497.542 60.2036 497.78 60.2584 497.963C60.6425 499.188 63.038 499.334 66.7868 499.718C72.7117 500.322 74.4855 500.797 74.9426 499.901C75.3815 499.078 74.3209 497.725 74.2112 497.579C73.5711 496.774 72.7848 496.481 71.2853 495.988C68.4874 495.073 66.6039 494.561 66.0187 494.415C62.4528 493.446 61.8677 493.281 61.3374 493.702Z",
    fill: "url(#paint10_linear_252_3717)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8676 488.288L65.4528 495.036C65.2882 495.365 63.2767 496.334 61.6858 495.493L60.168 488.855L64.8676 488.288Z",
    fill: "url(#paint11_linear_252_3717)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0913 346.512C70.6101 373.467 69.3849 400.934 68.4706 428.876C67.7757 449.85 67.2637 470.551 66.9345 490.995C64.4658 491.306 61.9971 491.599 59.5284 491.91C57.1329 487.466 53.9693 480.663 51.7931 471.959C49.1599 461.371 49.7633 455.099 48.6113 444.127C47.3129 431.82 45.4294 429.15 42.0829 413.624C35.2986 382.135 31.9155 366.39 39.4679 356.607C41.9183 353.425 49.617 345.452 72.0913 346.512Z",
    fill: "url(#paint12_linear_252_3717)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8752 266.124C44.2755 264.332 53.6383 262.229 65.104 261.57C82.0192 260.62 90.4859 260.199 95.4416 264.076C110.839 276.145 96.2462 319.247 101.732 341.904C106.359 360.958 106.523 361.288 106.523 361.288C107.621 363.427 109.376 366.371 108.681 369.901C108.133 372.68 106.03 375.862 103.177 376.85C97.252 378.898 93.8507 369.407 84.0307 366.554C73.7536 363.573 62.2696 369.498 47.7317 376.996C38.4786 381.769 35.3333 384.823 32.0783 383.305C25.8426 380.397 27.5432 364.451 28.2564 357.923C31.0177 332.066 34.1264 301.765 37.8752 266.124Z",
    fill: "url(#paint13_linear_252_3717)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3194 310.066C79.8805 309.975 79.0759 306.994 81.0326 306.116C89.8833 302.166 96.7408 309.993 97.6552 312.389C98.5695 314.803 98.5695 314.803 98.5695 314.803C98.5695 314.803 94.1624 315.15 91.4377 314.236C88.7313 313.303 83.9585 310.871 80.3194 310.066Z",
    fill: "url(#paint14_linear_252_3717)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M104.512 321.277L88.9319 322.063C88.3284 322.099 87.6152 321.35 87.7615 320.856L95.0396 297.303C95.1493 296.919 95.5516 296.644 95.9905 296.681L110.931 297.01C111.424 297.047 111.68 297.998 111.552 298.473L105.353 320.618C105.28 320.966 104.914 321.24 104.512 321.277Z",
    fill: "url(#paint15_linear_252_3717)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M104.237 320.764L88.5654 321.496C87.9619 321.532 87.5596 321.094 87.7059 320.582L94.7097 296.626C94.8194 296.242 95.2217 295.968 95.6789 296.004L110.637 296.882C111.131 296.919 111.46 297.376 111.332 297.851L105.115 320.088C105.005 320.454 104.621 320.746 104.237 320.764Z",
    fill: "url(#paint16_linear_252_3717)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.3189 306.483C96.7761 308.659 98.7511 308.202 100.342 310.835C102.372 314.181 100.433 317.144 102.28 318.369C102.847 318.735 103.816 318.973 105.535 318.515L105.097 320.106C104.987 320.472 104.621 320.765 104.237 320.783L88.5654 321.514C87.9619 321.551 87.5596 321.112 87.7059 320.6L94.7097 296.645C94.8194 296.261 95.2217 295.986 95.6789 296.023L97.9282 296.151C98.1842 296.974 98.3853 297.925 98.3671 298.985C98.2573 302.569 95.7703 303.923 96.3189 306.483Z",
    fill: "url(#paint17_linear_252_3717)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M111.37 304.727C111.461 304.343 111.278 303.959 110.986 303.941C109.852 303.868 107.2 303.831 105.738 305.093C103.836 306.739 101.385 309.738 103.452 311.255L105.372 312.663C105.463 312.737 105.555 312.755 105.646 312.718C106.323 312.499 109.212 311.603 109.523 311.383C109.852 311.164 110.949 306.537 111.37 304.727Z",
    fill: "url(#paint18_linear_252_3717)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M98.3865 367.761C96.7224 364.872 96.7773 360.483 93.1199 358.417C90.9804 357.21 89.3163 357.777 86.4087 357.703C77.7591 357.466 76.1133 352.035 70.1336 351.724C60.8805 351.23 56.4186 363.829 51.2252 362.019C47.8239 360.83 45.6477 354.046 47.4033 348.853C49.8537 341.611 58.229 342.617 69.1827 332.815C73.8824 328.628 80.6119 321.057 78.7649 317.729C76.8265 314.236 67.61 319.356 60.8074 314.145C56.8392 311.091 57.3512 307.324 54.0962 300.503C52.3407 296.809 45.9038 287.172 36.3398 280.698C33.2677 310.121 30.6161 335.686 28.2388 357.959C27.5439 364.469 25.825 380.434 32.0607 383.341C35.2975 384.859 38.4611 381.805 47.7141 377.032C62.252 369.535 73.7361 363.592 84.0132 366.591C93.8331 369.443 97.2344 378.916 103.159 376.886C105.006 376.246 106.542 374.673 107.53 372.9C102.263 371.93 99.6483 369.937 98.3865 367.761Z",
    fill: "url(#paint19_linear_252_3717)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7207 249.136C67.739 250.416 69.1105 256.304 64.7949 259.431C60.4426 262.576 56.4013 262.54 54.7738 262.942C50.9884 263.875 50.513 263.857 50.4216 264.222C50.0192 266.051 60.3329 272.287 70.9941 270.787C77.5224 269.873 83.4473 266.142 83.0815 264.186C82.7158 262.211 76.2058 263.271 74.2491 259.724C72.8959 257.255 74.4137 253.744 76.2058 250.818C74.4685 247.581 69.458 252.391 67.7207 249.136Z",
    fill: "url(#paint20_linear_252_3717)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M79.789 247.015C81.3068 244.948 81.3616 241.382 79.5696 239.151C78.0152 237.231 75.6196 236.975 74.175 236.829C70.0056 236.39 64.7573 238.201 62.9835 242.041C61.9229 244.327 64.3185 249.026 64.7025 249.867C65.1231 250.818 65.8911 251.148 66.586 251.861C67.5552 252.848 69.0913 254.439 71.5966 257.091C71.7794 256.304 72.0537 255.317 72.5109 254.256C72.6938 253.854 73.3887 252.245 74.4493 250.91C76.5705 248.222 78.3443 248.953 79.789 247.015Z",
    fill: "url(#paint21_linear_252_3717)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0306 254.86C68.0306 254.86 70.8284 259.322 76.2779 258.901C81.1604 258.536 81.7456 247.564 78.6003 245.278C77.5579 244.51 75.455 244.217 73.7726 244.711C72.7668 245.004 72.4377 245.424 70.8102 245.863C69.2924 246.265 68.8718 246.119 68.4146 246.503C67.8477 246.997 67.4454 248.185 68.4329 251.367C67.482 250.435 66.3665 250.087 65.5802 250.471C65.4522 250.526 65.123 250.764 64.9401 251.111C64.2635 252.391 65.4156 253.964 68.0306 254.86Z",
    fill: "url(#paint22_linear_252_3717)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1769 245.862C68.4146 246.027 67.7014 246.923 67.6649 248.167C67.5917 250.58 70.0604 253.451 72.5657 253.671C74.0469 253.799 74.4309 252.903 76.8631 252.629C78.3626 252.446 79.6244 252.629 80.4107 252.793C81.197 255.426 80.5204 258.078 78.7649 259.321C76.8814 260.656 74.4309 259.888 73.4069 259.559C72.7303 259.34 70.5359 258.663 69.3655 256.67C68.1586 254.604 69.3107 253.323 67.9209 251.934C67.226 251.239 66.3117 250.928 65.4339 249.575C65.1962 249.209 65.0316 248.88 64.9219 248.66C66.1837 247.307 67.8295 245.625 68.1769 245.862Z",
    fill: "url(#paint23_linear_252_3717)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9878 273.438C48.4094 269.525 43.2708 265.685 38.5346 266.014C24.7281 267.001 7.72152 304.196 19.3884 318.917C28.294 330.164 55.7972 330.712 80.9048 311.255C80.9048 309.097 80.9048 306.939 80.9048 304.8C68.543 306.958 58.3024 308.402 50.75 309.353C46.0321 309.938 41.3324 310.487 40.4547 308.64C39.138 305.842 48.5739 301.837 52.1764 291.396C52.6884 289.951 55.8337 280.808 50.9878 273.438Z",
    fill: "url(#paint24_linear_252_3717)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M302.741 485.838C302.704 485.838 302.649 485.856 302.613 485.856C295.353 487.008 286.264 486.204 280.394 481.376C277.304 478.834 275.201 475.469 274.561 471.501C274.177 469.142 273.976 466.655 274.342 464.278C274.726 461.791 275.695 459.395 276.92 457.219C277.615 456.012 278.401 454.824 279.224 453.708C281.62 450.49 287.27 445.991 284.655 441.438C283.064 438.695 279.425 436.994 277.011 435.056C271.855 430.923 268.142 424.98 268.106 418.195C268.069 412.856 271.416 407.571 275.183 403.987C290.544 389.394 279.224 364.286 300.967 366.261C322.71 368.236 327.428 389.942 319.29 410.204C316.565 416.988 313.237 423.919 311.39 431.014C309.927 436.592 311.994 440.45 316.547 443.76C318.998 445.534 322.563 446.741 324.685 448.844C329.439 453.507 333.225 460.054 332.091 466.911C330.975 473.714 325.178 478.706 319.071 481.284C313.768 483.534 308.373 484.942 302.741 485.838Z",
    fill: "url(#paint25_linear_252_3717)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.163 480.004C300.108 480.004 300.054 480.004 300.017 479.986C299.779 479.895 299.67 479.639 299.743 479.419C299.834 479.163 308.849 454.001 300.95 433.849C292.922 413.35 301.901 391.406 301.992 391.186C302.083 390.967 302.358 390.857 302.577 390.948C302.797 391.04 302.906 391.314 302.815 391.534C302.723 391.753 293.891 413.368 301.772 433.52C309.782 454.001 300.657 479.474 300.566 479.73C300.529 479.895 300.346 480.004 300.163 480.004Z",
    fill: "white"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M307.313 448.039C305.485 445.149 303.4 442.443 301.242 439.993C293.891 431.709 288.734 422.913 285.442 412.288C282.846 403.931 282.9 394.367 281.291 385.736C280.121 379.482 278 373.429 275.805 367.468C271.124 354.795 264.083 340.074 252.289 332.467C246.821 328.938 238.72 328.59 232.685 331.114C224.877 334.387 217.965 340.769 217.471 349.62C216.776 361.817 227.437 375.477 218.623 386.687C205.146 403.858 211.436 422.913 229.979 432.257C236.013 435.293 243.09 438.109 248.138 442.79C253.203 447.472 250.186 455.463 249.619 461.406C249.088 466.984 248.503 473.439 252.051 478.212C258.031 486.24 272.495 489.751 281.895 490.537C290.983 491.305 301.315 490.299 307.697 483.021C317.279 472.067 314.152 458.846 307.313 448.039Z",
    fill: "url(#paint26_linear_252_3717)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M292.518 482.985C292.335 482.985 292.171 482.875 292.098 482.692C291.805 481.906 262.4 404.316 245.613 373.045C245.503 372.826 245.576 372.552 245.796 372.442C246.015 372.332 246.29 372.405 246.399 372.625C263.205 403.95 292.628 481.595 292.921 482.381C293.012 482.619 292.884 482.875 292.665 482.967C292.628 482.985 292.573 482.985 292.518 482.985Z",
    fill: "white"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M279.81 493.957C281.767 493.683 283.723 493.354 285.662 493.043C291.093 492.165 297.822 490.483 299.523 484.43C300.017 482.711 299.176 479.62 298.974 477.828C298.773 476 298.517 474.171 298.078 472.379C297.493 469.91 296.542 467.588 295.335 465.357C293.214 461.498 290.8 458.591 286.302 457.731C283.028 457.091 279.389 456.945 276.043 457.055C257.866 457.658 255.635 451.093 245.651 437.085C235.666 423.078 169.962 445.735 209.589 470.605C209.589 470.605 215.551 474.482 237.312 471.94C241.298 471.483 246.327 471.172 249.692 473.75C255.635 478.285 249.655 487.904 255.672 491.69C259.183 493.884 264.797 494.542 268.838 494.688C272.495 494.835 276.171 494.487 279.81 493.957Z",
    fill: "url(#paint27_linear_252_3717)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.952 486.46C291.806 486.46 291.678 486.386 291.587 486.277C291.477 486.112 279.956 470.477 263.645 466.783C257.263 465.338 251.74 462.102 246.4 458.975C237.403 453.708 228.9 448.716 216.355 451.276C216.118 451.331 215.88 451.166 215.825 450.929C215.77 450.691 215.935 450.453 216.172 450.398C229.065 447.765 238.098 453.068 246.858 458.188C252.142 461.279 257.592 464.479 263.846 465.887C280.505 469.654 292.208 485.564 292.318 485.728C292.464 485.929 292.41 486.204 292.227 486.35C292.135 486.441 292.044 486.46 291.952 486.46Z",
    fill: "white"
  }))), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M388.541 500.815L286.666 494.305V339.234L388.541 342.16V500.815Z",
    fill: "url(#paint28_linear_252_3717)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M477.67 493.227L388.541 500.816V342.16L477.67 340.313V493.227Z",
    fill: "url(#paint29_linear_252_3717)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M286.666 339.234L383.567 335.028L477.67 340.313L387.48 343.641L286.666 339.234Z",
    fill: "url(#paint30_linear_252_3717)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M400.206 261.826C397.829 260.29 399.987 255.809 400.115 246.209C400.28 234.432 397.153 232.238 399.658 227.611C402.73 221.961 410.465 219.62 415.586 219.51C416.719 219.492 416.975 218.87 426.448 221.321C443.509 225.746 447.77 221.01 455.414 225.728C462.783 230.299 459.565 235.31 466.733 240.668C478.345 249.354 490.561 239.955 498.863 247.233C506.708 254.109 506.891 271.609 498.644 281.173C489.281 291.999 472.402 288.744 461.083 286.604C458.706 286.147 446.673 283.623 434.165 274.389C427.234 269.268 422.48 263.819 419.462 259.796C418.749 258.991 417.652 258.022 416.189 257.876C414.433 257.693 413.025 258.753 412.349 259.229C408.728 261.698 402.529 263.325 400.206 261.826Z",
    fill: "url(#paint31_linear_252_3717)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M408.235 248.128C405.182 245.349 394.301 250.707 387.096 257.82C378.629 266.177 379.269 272.943 371.882 283.312C368.206 288.469 361.897 295.418 350.742 301.489C351.529 303.464 352.315 305.439 353.119 307.414C358.514 307.743 369.12 307.542 379.013 301.087C385.889 296.606 389.419 290.663 396.203 278.96C403.005 267.22 412.057 251.603 408.235 248.128Z",
    fill: "url(#paint32_linear_252_3717)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M339.495 406.967L347.998 401.865H351.838C351.838 401.865 353.137 406.729 352.991 406.967C351.29 409.765 343.335 411.905 338.361 412.069C337.538 412.106 336.386 412.106 336.094 411.502C335.582 410.497 337.831 408.375 339.495 406.967Z",
    fill: "url(#paint33_linear_252_3717)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M348.144 396.287C348.693 399.451 347.998 401.096 347.248 402.011C346.718 402.669 346.261 402.852 343.152 405.54C342.128 406.436 341.598 406.912 341.726 407.149C341.854 407.442 342.768 407.277 344.725 406.802C349.004 405.778 351.143 405.248 351.674 404.205C352.149 403.273 351.729 402.852 351.765 400.31C351.784 398.646 352.131 397.293 352.387 396.452C350.961 396.415 349.553 396.342 348.144 396.287Z",
    fill: "url(#paint34_linear_252_3717)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M341.999 371.234C341.999 371.234 338.159 375.806 338.781 380.835C339.403 385.864 346.132 378.512 347.065 376.025C347.997 373.538 349.095 370.009 349.095 370.009C349.095 370.009 344.395 367.083 341.999 371.234Z",
    fill: "url(#paint35_linear_252_3717)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M343.463 364.066C343.463 364.066 344.505 369.406 342.512 372.222C341.524 373.63 340.189 374.819 340.573 375.953C340.829 376.721 341.835 377.269 342.676 377.178C344.304 377.013 345.2 374.526 345.822 372.771C346.754 370.192 347.285 364.652 347.285 364.652L343.463 364.066Z",
    fill: "url(#paint36_linear_252_3717)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M346.536 368.565C345.348 368.126 344.177 367.705 342.989 367.266C341.142 363.06 338.892 356.148 339.642 347.755C341.581 326.158 361.55 314.711 363.762 313.485C369.212 316.21 374.716 320.069 374.917 324.933C375.173 331.022 366.871 334.259 359.063 343.165C354.381 348.523 349.371 356.496 346.536 368.565Z",
    fill: "url(#paint37_linear_252_3717)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M347.796 398.757C343.901 383.524 344.889 371.089 346.022 363.921C347.723 353.095 351.179 331.078 365.882 322.867C369.1 321.075 373.69 319.466 379.268 314.492C383.931 310.322 386.911 305.952 388.704 302.861C408.362 297.101 426.502 299.423 434.512 309.975C435.444 311.2 437.748 313.833 438.206 317.728C439.211 326.524 430.58 337.112 420.888 339.325C408.563 342.141 401.413 329.487 390.496 333.693C387.442 334.863 384.845 337.789 379.67 343.622C373.087 351.047 369.375 357.904 367.985 360.629C363.815 368.785 360.652 374.819 360.195 382.628C360.085 384.438 360.03 388.114 357.89 392.082C356.263 395.118 354.032 397.147 352.386 398.409C350.85 398.519 349.332 398.647 347.796 398.757Z",
    fill: "url(#paint38_linear_252_3717)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M438.206 317.728C437.767 313.833 435.444 311.182 434.512 309.975C426.502 299.423 408.38 297.101 388.704 302.861C386.912 305.952 383.949 310.322 379.268 314.492C373.672 319.484 369.082 321.075 365.882 322.867C356.903 327.878 352.13 338.045 349.369 347.664C353.447 341.337 356.958 339.654 359.665 339.618C363.541 339.581 365.26 342.891 369.887 342.434C374.824 341.958 375.958 337.862 379.963 337.387C381.17 337.24 382.633 337.423 384.406 338.374C386.765 335.905 388.539 334.424 390.478 333.674C401.395 329.468 408.545 342.123 420.87 339.307C430.562 337.112 439.212 326.524 438.206 317.728Z",
    fill: "url(#paint39_linear_252_3717)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M357.982 329.67C360.213 329.56 363.633 329.487 367.766 329.889C387.387 331.827 392.8 341.538 409.002 343.897C412.842 344.463 429.922 346.95 437.31 337.076C442.613 329.98 441.809 317.765 436.012 312.974C433.561 310.944 431.111 310.999 415.384 311.145C409.459 311.2 403.535 311.218 397.591 311.291C372.502 311.602 367.693 309.865 363.121 314.016C361.018 315.973 357.891 320.124 357.982 329.67Z",
    fill: "url(#paint40_linear_252_3717)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M410.977 249.153C410.977 249.153 440.254 240.613 443.308 262.045C446.215 282.6 431.293 292.017 438.096 312.846C438.882 315.26 382.34 304.214 382.34 304.214C389.892 294.797 391.648 287.025 391.812 281.63C392.013 275.706 390.295 273.017 391.812 266.014C391.812 266.014 393.495 258.205 399.566 251.494C400.444 250.543 401.486 249.537 410.977 249.153Z",
    fill: "url(#paint41_linear_252_3717)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M429.774 308.457C429.737 308.457 429.719 308.457 429.682 308.439C429.408 308.366 402.051 301.088 385.904 300.174C385.721 300.155 385.575 300.009 385.593 299.826C385.612 299.643 385.74 299.497 385.941 299.515C402.161 300.43 429.591 307.726 429.865 307.799C430.048 307.854 430.158 308.037 430.103 308.22C430.067 308.348 429.92 308.457 429.774 308.457Z",
    fill: "#F4F7FA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M417.322 236.298C417.048 237.56 415.695 244.271 418.438 246.008C419.041 246.392 420.175 246.593 422.479 247.032C423.979 247.306 425.24 247.489 426.137 247.599C426.009 248.733 425.624 250.561 424.326 252.226C420.669 256.907 413.354 255.7 412.312 255.499C408.636 254.822 405.015 253.688 404.138 252.994C402.803 251.933 401.76 251.147 401.139 250.342C402.565 249.647 405.436 247.837 407.374 247.252C408.819 246.813 410.172 246.484 411.397 246.264C411.599 244.966 411.8 243.667 412.001 242.369C413.775 240.339 415.549 238.328 417.322 236.298Z",
    fill: "url(#paint42_linear_252_3717)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M417.414 239.827C417.414 239.827 416.956 244.417 412.494 245.222C408.508 245.953 405.491 236.298 407.539 233.792C408.215 232.951 409.898 232.165 411.361 232.201C412.385 232.238 415.859 233.555 416.335 237.029C417.03 236.298 417.889 236.096 418.31 236.389C418.84 236.773 418.566 237.907 418.493 238.163C418.273 239.059 417.688 239.608 417.414 239.827Z",
    fill: "url(#paint43_linear_252_3717)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M376.363 306.611L421.184 308.787C421.806 308.824 422.372 309.153 422.683 309.665L423.927 311.658C424.549 312.646 423.799 313.926 422.628 313.889L375.156 312.079L376.363 306.611Z",
    fill: "url(#paint44_linear_252_3717)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M329.733 281.65L376.034 282.546C377.406 282.564 378.668 283.314 379.344 284.502L395.382 312.719L346.483 310.762C345.148 310.707 343.923 309.976 343.228 308.824L328.379 284.009C327.739 282.966 328.507 281.631 329.733 281.65Z",
    fill: "url(#paint45_linear_252_3717)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M379.344 284.521C378.667 283.332 377.406 282.582 376.034 282.564L375.028 282.546C374.882 284.045 374.425 285.417 373.51 286.514C370.658 289.952 365.903 287.831 362.374 291.488C358.497 295.493 362.081 300.266 358.607 303.996C354.949 307.928 349.043 304.728 342.24 307.233L343.228 308.86C343.923 310.012 345.148 310.744 346.483 310.799L395.381 312.755L379.344 284.521Z",
    fill: "url(#paint46_linear_252_3717)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M417.527 305.111C416.942 303.575 416.357 302.039 415.771 300.484C422.227 298.71 431.132 296.095 440.276 292.84C441.702 292.328 443.403 291.688 443.97 290.189C445.542 285.965 435.594 281.576 431.717 272.341C428.152 263.801 430.108 251.951 434.259 250.543C442.891 247.636 473.502 285.745 462.567 301.801C456.423 310.908 437.368 312.352 417.527 305.111Z",
    fill: "url(#paint47_linear_252_3717)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M415.788 300.502C411.747 298.345 406.901 300.557 406.59 300.704C405.694 301.124 404.414 301.874 403.097 303.209C402.951 303.41 401.195 305.842 401.835 306.628C402.347 307.25 404.341 306.738 406.718 305.257C407.724 305.111 409.205 304.983 410.997 305.147C414.27 305.458 415.77 306.482 416.958 305.586C417.836 304.928 418.129 303.556 417.818 302.514C417.47 301.417 416.465 300.868 415.788 300.502Z",
    fill: "url(#paint48_linear_252_3717)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_252_3717",
    x1: 181.212,
    y1: 253.566,
    x2: 102.542,
    y2: 262.148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_252_3717",
    x1: 250.528,
    y1: 55.2617,
    x2: 55.9983,
    y2: 717.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_252_3717",
    x1: 177.633,
    y1: 38.9491,
    x2: -50.9919,
    y2: 658.141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_252_3717",
    x1: 168.627,
    y1: 251.405,
    x2: 346.059,
    y2: 63.3929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_252_3717",
    x1: 265.338,
    y1: 53.8872,
    x2: 134.72,
    y2: 464.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_252_3717",
    x1: 114.622,
    y1: 214.201,
    x2: 304.198,
    y2: 214.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_252_3717",
    x1: 34.7358,
    y1: 489.468,
    x2: 28.3551,
    y2: 476.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_252_3717",
    x1: 31.1111,
    y1: 481.812,
    x2: 39.2785,
    y2: 469.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_252_3717",
    x1: 122.252,
    y1: 432.835,
    x2: 71.3267,
    y2: 421.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_252_3717",
    x1: 94.1965,
    y1: 301.471,
    x2: 107.026,
    y2: 287.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_252_3717",
    x1: 74.9883,
    y1: 496.728,
    x2: 60.2212,
    y2: 497.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_252_3717",
    x1: 66.5209,
    y1: 496.936,
    x2: 58.4451,
    y2: 484.416,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_252_3717",
    x1: 97.2273,
    y1: 471.585,
    x2: 44.1199,
    y2: 383.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_252_3717",
    x1: 38.5234,
    y1: 356.607,
    x2: 87.0408,
    y2: 304.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_252_3717",
    x1: 79.7693,
    y1: 309.943,
    x2: 98.5778,
    y2: 309.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_252_3717",
    x1: 96.6484,
    y1: 306.001,
    x2: 102.615,
    y2: 312.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_252_3717",
    x1: 81.2874,
    y1: 312.667,
    x2: 108.473,
    y2: 306.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_252_3717",
    x1: 95.7508,
    y1: 323.238,
    x2: 101.907,
    y2: 297.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_252_3717",
    x1: 101.253,
    y1: 299.985,
    x2: 115.368,
    y2: 317.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_252_3717",
    x1: 41.7404,
    y1: 359.588,
    x2: 90.2579,
    y2: 307.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_252_3717",
    x1: 58.8435,
    y1: 280.907,
    x2: 78.5151,
    y2: 239.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_252_3717",
    x1: 61.8939,
    y1: 269.95,
    x2: 73.768,
    y2: 238.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_252_3717",
    x1: 72.3787,
    y1: 247.182,
    x2: 75.2871,
    y2: 292.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_252_3717",
    x1: 65.6851,
    y1: 271.394,
    x2: 77.5714,
    y2: 239.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_252_3717",
    x1: 45.6332,
    y1: 329.375,
    x2: 52.6554,
    y2: 269.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_252_3717",
    x1: 268.068,
    y1: 426.251,
    x2: 332.273,
    y2: 426.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_252_3717",
    x1: 211.377,
    y1: 410.131,
    x2: 313.727,
    y2: 410.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_252_3717",
    x1: 196.999,
    y1: 463.767,
    x2: 299.672,
    y2: 463.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_252_3717",
    x1: 713.151,
    y1: 268.499,
    x2: 442.107,
    y2: 382.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_252_3717",
    x1: 424.934,
    y1: 406.926,
    x2: 507.661,
    y2: 548.209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_252_3717",
    x1: 343.385,
    y1: 275.083,
    x2: 390.962,
    y2: 354.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_252_3717",
    x1: 393.272,
    y1: 216.267,
    x2: 519.361,
    y2: 301.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_252_3717",
    x1: 381.049,
    y1: 258.388,
    x2: 377.796,
    y2: 310.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_252_3717",
    x1: 336.019,
    y1: 406.965,
    x2: 353,
    y2: 406.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_252_3717",
    x1: 344.027,
    y1: 413.656,
    x2: 369.362,
    y2: 337.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_252_3717",
    x1: 338.721,
    y1: 375.784,
    x2: 349.106,
    y2: 375.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_252_3717",
    x1: 332.702,
    y1: 404.301,
    x2: 349.66,
    y2: 353.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_252_3717",
    x1: 353.599,
    y1: 318.59,
    x2: 366.247,
    y2: 391.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_252_3717",
    x1: 371.46,
    y1: 405.253,
    x2: 389.445,
    y2: 348.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_252_3717",
    x1: 371.462,
    y1: 405.254,
    x2: 389.446,
    y2: 348.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_252_3717",
    x1: 396.769,
    y1: 311.21,
    x2: 409.388,
    y2: 384.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB316D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792D3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_252_3717",
    x1: 378.523,
    y1: 265.915,
    x2: 490.623,
    y2: 306.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_252_3717",
    x1: 416.853,
    y1: 263.566,
    x2: 409.461,
    y2: 230.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_252_3717",
    x1: 412.18,
    y1: 234.259,
    x2: 420.07,
    y2: 274.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_252_3717",
    x1: 375.161,
    y1: 310.258,
    x2: 424.154,
    y2: 310.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_252_3717",
    x1: 343.831,
    y1: 279.353,
    x2: 375.952,
    y2: 311.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_252_3717",
    x1: 343.831,
    y1: 279.353,
    x2: 375.952,
    y2: 311.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_252_3717",
    x1: 446.436,
    y1: 264.071,
    x2: 437.872,
    y2: 311.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_252_3717",
    x1: 405.842,
    y1: 300.596,
    x2: 422.128,
    y2: 315.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactNativeDevelopent);
export default __webpack_public_path__ + "static/media/ReactNativeDevelopent.df679d19cc3250544b9c99ad6648ee6a.svg";
export { ForwardRef as ReactComponent };